import React, { useState } from "react";

export default function Feature() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <>
        <div className="first_nav_hero_about">
          {/* ======== 1.1. header section ======== */}
          <header>
            <nav className="container navbar navbar-expand-lg ">
              <div className="container-fluid">
                {/* site logo */}
                <a className="nav-logo p-0" href="/">
                  <img src="/assets/images/new_logo.svg" alt="logo" />
                </a>
                {/* navigation button  */}
                <button
                  className="navbar-toggle"
                  onClick={toggleNavbar}
                  type="button"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  <i className="fa-solid fa-bars" />
                </button>
                {/* navigation bar manu  */}
                <div
                  className={`mobileNav collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent"
                >
                  <ul className="navbar-nav d-flex justify-content-center align-items-center gap-lg-2 gap-md-2 gap-sm-2 gap-2 mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a className="nav-link active" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/aboutus">
                        About us
                      </a>
                    </li>
                    {/*
            <li className="nav-item">
              <a className="nav-link" href="/feature">
                Solutions
              </a>
            </li>*/}
                    <li className="nav-item">
                      <a className="nav-link" href="/Contactus">
                        Contact Us
                      </a>
                    </li>

                    {/* <li className="nav-item">
              <a className="nav-link" href="/FAQ">
                FAQ's
              </a>
            </li>*/}
                    {/* <li className="dropdown">
        <a className="nav-link " href="#">
          Pages <i className="fa-sharp fa-solid fa-sort-down" />
        </a>
        <ul className="dropdown-menu">
          <li>
            <a className="dropdown-item" href="pricing.html">
              Pricing
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="contact.html">
              Contact
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="team.html">
              Team
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="testimonials.html">
              Testimonials
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="blogs.html">
              Blogs
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="faq.html">
              FAQ
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="404.html">
              404
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="coming.html">
              Coming Soon
            </a>
          </li>
        </ul>
      </li> */}
                    {/* <li className="nav-item">
        <a id="search-bar-bt" className="nav-link" href="#">
          <i className="fa-solid fa-magnifying-glass" />
        </a>
      </li> 

            <a className=" btn-hover4" href="#">
              Create Account
            </a>*/}

                    {/* <li
        className="nav-item"
        onclick="if (!window.__cfRLUnblockHandlers) return false; open_right_side()"
        data-cf-modified-2a89ad8e51888e2ea151ec41-=""
      >
        <a className="nav-link" href="#">
          <i className="fa-sharp fa-solid fa-bars" />
        </a>
      </li> */}
                  </ul>
                </div>
              </div>
            </nav>
            {/*============ navigation left slidebar================*/}
            <aside>
              <div id="mySidenav" className="sidenav">
                <div className="side-nav-logo d-flex justify-content-between align-items-center ps-4 pe-3">
                  <figure className="navbar-brand">
                    <a href="/">
                      <img
                        src="/assets/images/new_logo.svg"
                        alt="img"
                        className="nav-logo"
                      />
                    </a>
                  </figure>
                  <div
                    className="closebtn"
                    onclick="if (!window.__cfRLUnblockHandlers) return false; closeNav()"
                    data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                  >
                    <i className="fa-solid fa-square-xmark side-bar-close-btn" />
                  </div>
                </div>
                <ul>
                  <li className="nav-item">
                    <a className="nav-link" aria-current="page" href="/">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="about.html">
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/feature">
                      Solutions
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="pricing.html">
                      Pricing
                    </a>
                  </li>
                  <li className="nav-item">
                    <div
                      className="d-flex align-items-center justify-content-between pt-3"
                      id="slid-btn"
                    >
                      <button className="a-slid">Pages</button>
                      <i className="fa-solid fa-caret-down pe-4" />
                    </div>
                    <ul id="slid-drop" className="myst">
                      <li>
                        <a href="contact.html">Contact</a>
                      </li>
                      <li>
                        <a href="team.html">Team</a>
                      </li>
                      <li>
                        <a href="testimonials.html">Testimonials</a>
                      </li>
                      <li>
                        <a href="blogs.html">Blogs</a>
                      </li>
                      <li>
                        <a href="faq.html">FAQ</a>
                      </li>
                      <li>
                        <a href="404.html">404</a>
                      </li>
                      <li>
                        <a href="coming.html">Coming Soon</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </aside>
            {/*================== navigation drop search bar================*/}
            <div className="search" id="search-bar">
              <form className="d-flex nav-search">
                <input type="text" name="search" placeholder="Enter your text" />
                <button className="btn-hover1" type="submit">
                  Search
                </button>
              </form>
              <button id="remove-btn">
                <i className="fa-solid fa-square-xmark " />
              </button>
            </div>
            {/*=================navigation Right slidebar==================*/}
            <section className="right-sidbar" id="right_side">
              <div className="d-flex justify-content-between align-items-center">
                {/* site logo */}
                <a className="p-0 " href="/">
                  <img src="/assets/images/new_logo.svg" alt="logo" />
                </a>
                <button
                  className="close_right_sidebar fa-solid fa-xmark"
                  onclick="if (!window.__cfRLUnblockHandlers) return false; close_right_sade()"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  {" "}
                </button>
              </div>
              <p className="mt-4 pb-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <a href="#" className="btn-hover1">
                Discover More
              </a>
              <hr />
              <h5 className="mt-4 mb-4">Connected details:</h5>
              <ul className="d-flex flex-column gap-3">
                <li>
                  <a href="#">
                    {" "}
                    <i className="fa-solid fa-phone" />
                  </a>
                  <a href="#">
                    <span
                      className="__cf_email__"
                      data-cfemail="71081e04031f101c1431141c10181d5f121e1c"
                    >
                      [email&nbsp;protected]
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-solid fa-envelope" />
                  </a>
                  <a href="#">+123-456-7890</a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-solid fa-clock" />
                  </a>
                  <a href="#">
                    Office Hours: 8AM - 11PM Sunday - Weekend Day
                  </a>
                </li>
              </ul>
              <span className="d-flex gap-4 mt-4">
                <a href="#" className="p-0">
                  <i className="fa-brands fa-facebook" />
                </a>
                <a href="#" className="p-0">
                  <i className="fa-brands fa-instagram" />
                </a>
                <a href="#" className="p-0">
                  <i className="fa-brands fa-twitter" />
                </a>
              </span>
            </section>
          </header>
          {/* ======== End of 1.1. header section ========  */}
          {/* ======== 3.1. hero section ========  */}
          <section className="feature-hero" data-aos="zoom-in">
            <div className="container">
              <h1 className="text-center">FEATURES</h1>
              <p className="text-center">
                Experience seamless and secure transactions with Finkey Pay, designed to simplify online payments for businesses and customers alike.        </p>
              <div className="position-relative">
                <div className="featur-video">

                </div>
                <figure className="feature-img">
                  <img className='img-fluid w-50' src="/assets/New/image8.png " alt="img" />
                </figure>

              </div>
            </div>
          </section>
          {/* ======== End of 3.1. hero section ========  */}
        </div>
        {/* ======== 1.7. services section ========  */}
        <section className="services">
          <div className="container">
            <div className="row gap-md-0 gap-sm-4 gap-4">
              <div className="col-lg-6 col-md-6" data-aos="fade-down">
                <h2 className="text-lg-start text-md-start text-sm-center text-center">
                  EXCEPTIONAL SERVICES AND SOLUTIONS
                </h2>
                <p className="text-lg-start text-md-start text-sm-center text-center mt-lg-4 mt-md-2 mt-sm-2 mt-2 pb-4 ">
                  At Finkey Pay, we offer cutting-edge payment solutions tailored to your needs. Our platform ensures smooth transactions with security, speed, and transparency at its core.
                </p>
                <div className=" d-flex  justify-content-center gap-lg-4 gap-md-3 gap-sm-2 gap-2">
                  <div className="offers">
                    <h5 className="mb-2">Any Time Transection</h5>
                    <p className="p-f-s">
                      Make payments anytime, anywhere, without restrictions. Our platform operates 24/7 to keep your business running smoothly!
                    </p>
                  </div>
                  <div className="offers">
                    <h5 className=" mb-2">Zero Hidden Cost</h5>
                    <p className="p-f-s">
                      We believe in transparent pricing—no hidden fees, no surprises. Enjoy competitive rates with no extra charges!
                    </p>
                  </div>
                </div>
                <div className="serives-btn justify-content-md-start justify-content-ms-center justify-content-center d-flex">
                  <a className="btn-hover1" href="#">
                    Learn More
                  </a>
                  <div className="d-flex align-items-center">
                    <a className="ps-4" href="#">
                      Register Now{" "}
                    </a>
                    <i className="fa-solid fa-greater-than ps-md-3 ps-sm-1 ps-0" />
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center sevices_img"
                data-aos="fade-up"
              >
                <div className="position-relative px-4">


                  <img
                    className='w-100 '
                    src="/assets/New/Exceptional.svg"
                    alt="sevice_img2"
                  />

                  <figure>
                    <img src="/assets/images/icon/whitStar.png" alt="sevice_img3" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.7. services section ========  */}
        {/* ======== 3.2. core section ========  */}
        <section className="core">
          <div className="container">
            <h2 className="text-center">CORE FEATURES</h2>
            <p className="core-p">
              Finkey Pay uses advanced encryption and fraud detection mechanisms to safeguard your payments and data!
            </p>
            <div className="row d-flex gap-md-0 gap-sm-5 gap-5">
              <div
                className="col-lg-4 col-md-4 d-flex flex-column gap-3 justify-content-center"
                data-aos="fade-up"
              >
                <div className="core-card">
                  <h5>Secure Transactions</h5>
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Non
                    veniam reiciendis molestiae.
                  </p>
                </div>
                <div className="core-card">
                  <h5>Seamless Integration</h5>
                  <p>
                    Easily integrate Finkey Pay with your existing business systems, whether it's an e-commerce site, app, or ERP.
                  </p>
                </div>
                <div className="core-card">
                  <h5>Robust Security</h5>
                  <p>
                    Our platform is PCI DSS compliant, ensuring that all transactions are protected against unauthorized access.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-4 d-flex justify-content-center align-items-center"
                data-aos="zoom-in"
              >
                <figure>
                  <img
                    src="/assets/New/image 7.svg"
                    alt="img"
                    className="moving"
                  />
                </figure>
              </div>
              <div
                className="col-lg-4 col-md-4 d-flex flex-column gap-3 justify-content-center"
                data-aos="fade-down"
              >
                <div className="core-card1">
                  <h5>Multiple Payment</h5>
                  <p>
                    Accept payments via credit cards, debit cards, UPI, net banking, and digital wallets, all in one place.
                  </p>
                </div>
                <div className="core-card1">
                  <h5>Customizable Checkout</h5>
                  <p>
                    Enhance customer experience with a personalized checkout page that matches your brand identity.


                  </p>
                </div>
                <div className="core-card1">
                  <h5>Reporting and Analytics</h5>
                  <p>
                    Gain insights into your transactions with detailed reports, helping you make data-driven business decisions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 3.2. core section ========  */}
        {/* ======== 1.8. visa section ========  */}
        <section className="visa mt-md-5 mt-sm-5 mt-5 mb-0">
          <div className="container">
            <div className="visa-bg" data-aos="zoom-in">
              <figure>
                <img src="/assets/New/Replacing.svg" alt="visa-img" />
              </figure>
            </div>
            <div className="visa-contant" data-aos="fade-up">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <h3 className="text-md-start text-sm-center text-center">
                    Replacing complexity with simplicity
                  </h3>
                  <p className="text-md-start text-sm-center text-center p-f-s">
                    Finkey Pay eliminates the hassle of payment processing, providing businesses with a user-friendly, scalable, and efficient solution.
                  </p>
                  <p className="text-md-start text-sm-center text-center p-f-s">
                  </p>
                  <div className="visa-btn text-sm-center text-md-start text-center">
                    <a className="btn-hover1" href="#">
                      Try FinkeyPay Now
                    </a>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="visa-logo pt-2 pb-3">
                    <figure>
                      <img src="/assets/images/icon/vis-1.png" alt="vica-icon1" />{" "}
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-2.png" alt="vica-icon2" />
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-3.png" alt="vica-icon3" />
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-4.png" alt="vica-icon4" />
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-5.png" alt="vica-icon5" />
                    </figure>
                  </div>
                  <div className="d-flex pt-2 justify-content-md-start justify-content-center justify-content-center">
                    <h2 className="count">280</h2>
                    <h2>+</h2>
                    <h6 className="d-flex align-items-center ps-2 ">Integrations</h6>
                  </div>
                  <p className="pt-2 pb-3 text-md-start text-sm-center text-center p-f-s">
                    Our platform integrates with popular e-commerce platforms making payment collection easier than ever.

                  </p>
                  <div className="visa-card position-relative mt-3">
                    <img src="/assets/New/Group 6@2x.svg" alt="visa-card" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.8. visa section ========  */}
        {/* ======== 1.13. footer section ========  */}
        <footer className="position-relative">
          <div className="container">
            <h4 className="text-center">SUBSCRIBE OUR NEWSLETTER</h4>
            <p className="text-center pt-2 pb-3">Get latest News and Updates</p>
            <form
              className="d-flex align-items-center justify-content-center"
              id="footer-sub2"
            >
              {/* form Subscribe massage */}
              <div id="Succes-box2" />
              <div className="d-flex footer-search">
                <input
                  type="email"
                  name="search"
                  placeholder="Enter your Email"
                  required=""
                />
                <button type="submit" className="btn-hover1">
                  Subscribe
                </button>
              </div>
            </form>
            <div className="footer-logo text-center pb-lg-4 pb-md-3 pb-sm-2 pb-4">
              {/* footer logo  */}
              <a href="/">
                <figure>
                  <img src="/assets/images/new_logo.svg" alt="img" />
                </figure>
              </a>
            </div>
            <ul className="d-flex align-items-center justify-content-center">
              {/*<li>
                <a className="foot" href="/feature">Solutions</a>
              </li>*/}
              <li>
                <a className="foot" href="/Contactus">Contact Us</a>
              </li>
              <li>
                <a className="foot" href="/aboutus">About us</a>
              </li>
              {/*<li>
                <a className="foot" href="/FAQ">Faq</a>
              </li>*/}
            </ul>
            <hr />
            <div className="d-flex justify-content-center footer-nav-icon">
              {/* footer social icon  
              <div className="col-lg-3 col-md-3 d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-center">
                <div className="social-icon d-flex gap-2 justify-content-md-start justify-content-sm-center justify-content-center">
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-facebook-f foot-facebook" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-twitter" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-instagram" />
                  </a>
                </div>
              </div>
              */}
              {/* footer terms privacy  */}
              <div className="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
                <div className=" d-flex gap-3 p-2">
                  <a target="_blank" href="/assets/pdfs/Terms&Condition_Finkey.pdf" className="footer-terms">Terms &amp; Condition</a>
                  <a target="_blank" href="/assets/pdfs/Privacy_Policy_Finkey.pdf" className="footer-terms" >Privacy Policy</a>
                  <a target="_blank" href="/assets/pdfs/Refund_Policy_Finkey.pdf" className="footer-terms" >Refund Policy</a>
                </div>
              </div>
              {/* footer logo slider  */}
            </div>
            <hr />
            <div className="Copyright d-flex justify-content-between flex-wrap dir">
              <a className="footer-copyright">Copyright © 2024 FinkeyPay. All Right Reserved.</a>
              <a className="footer-copyright">FinkeyPay</a>
            </div>
          </div>
        </footer>
      </>

    </div>
  )
}
